import { ReactNode } from 'react';

import { Header } from '@/layout/header/Header';
import { AdminNavSidebar } from './AdminNavSidebar';
import { RouteErrorBoundary } from '@/components/error-boundary';

interface AdminLayoutProps {
  children: ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div className="flex flex-col h-screen bg-sidebar">
      <Header />
      <div className="flex flex-1 min-h-0">
        <AdminNavSidebar />
        <main className="flex-1 mb-4 mr-4 overflow-auto border bg-background rounded-2xl border-border">
          <RouteErrorBoundary>{children}</RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
